import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = {
  key: 1,
  class: "error-message"
}

import {
  computed,
  nextTick,
  onBeforeUnmount,
  ref,
  watch,
  watchEffect,
} from "vue";
import { useI18n } from "vue-i18n";
import MultiSelect from "primevue/multiselect";


export default /*@__PURE__*/_defineComponent({
  __name: 'base-multiselect',
  props: {
    options: {},
    radius: { default: "6px" },
    background: { default: "#fff" },
    placeholder: {},
    value: {},
    isEmpty: { type: Boolean, default: true },
    loading: { type: Boolean },
    remote: { type: Boolean, default: false }
  },
  emits: [
  "update:modelValue",
  "change",
  "search",
  "scroll-end",
],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v4e3323e2": (_ctx.radius),
  "ab2d5faa": (_ctx.background)
}))

const { t } = useI18n();

const emit = __emit;

const props = __props;

const root = ref<HTMLElement | null>(null);
const scrollElement = ref<HTMLElement | null>(null);

const internalValue = ref<any[]>([]); // Alterando para array

const internalOptions = computed(() => {
  const optionEmpty = {
    label: t("common.placeholders.select"),
    value: "empty",
  };

  const optionsFormatted = (props.options || []).map((item) => ({
    label: item.option,
    value: item.value,
  }));

  return props.isEmpty ? [optionEmpty, ...optionsFormatted] : optionsFormatted;
});

function update(data: { originalEvent: Event; value: any[] }) {
  internalValue.value = data.value.filter((val) => val !== "empty"); // Remove "empty" se presente
  emit("update:modelValue", internalValue.value);
  emit("change", internalValue.value);
}

function onFilter(data: { originalEvent: Event; value: string }) {
  if (!props.remote) return;

  emit("search", data.value ?? "");
}

function findScrollElement() {
  const listId = root.value
    ?.querySelector("[aria-controls]")
    ?.getAttribute("aria-controls");

  if (!listId) return null;

  const list = document.getElementById(listId);

  return (list?.closest(".p-multiselect-items-wrapper") ??
    null) as HTMLElement | null;
}

function onScroll(event: Event) {
  if (!props.remote) return;

  const target = event.target as HTMLElement;
  const reachedEnd =
    target.scrollTop + target.clientHeight >= target.scrollHeight - 24;

  if (reachedEnd) emit("scroll-end");
}

function detachScroll() {
  scrollElement.value?.removeEventListener("scroll", onScroll);
  scrollElement.value = null;
}

async function attachScroll() {
  await nextTick();

  detachScroll();

  scrollElement.value = findScrollElement();
  scrollElement.value?.addEventListener("scroll", onScroll, {
    passive: true,
  });
}

function onShow() {
  if (props.remote) attachScroll();
}

function onHide() {
  detachScroll();
}

watch(
  () => props.options,
  (next, prev) => {
    if (!props.remote || !scrollElement.value) return;

    if (next.length < prev.length) scrollElement.value.scrollTop = 0;
  }
);

onBeforeUnmount(detachScroll);

watchEffect(() => {
  if (props.value !== undefined) internalValue.value = props.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "base-multiselect"
  }, [
    (_ctx.$slots.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "label")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["content", { error: _ctx.$slots.error }])
    }, [
      (!__props.loading)
        ? (_openBlock(), _createBlock(_unref(MultiSelect), _mergeProps({
            key: 0,
            class: "custom-multiselect"
          }, _ctx.$attrs, {
            modelValue: internalValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
            options: internalOptions.value,
            optionLabel: "label",
            optionValue: "value",
            placeholder: 
          __props.placeholder ? __props.placeholder : _unref(t)('common.placeholders.select')
        ,
            onChange: update,
            onFilter: onFilter,
            onShow: onShow,
            onHide: onHide,
            display: "chip",
            filter: true,
            showClear: true
          }), null, 16, ["modelValue", "options", "placeholder"]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.$slots.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "error")
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})